export default __webpack_public_path__ + "static/media/cal1.b71bdb7e.svg";